// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBwchRdT0a1Kfx9WxsYaa9EJ7Ak01pMOfQ",
    authDomain: "delivery-local.firebaseapp.com",
    databaseURL: "https://delivery-local.firebaseio.com",
    projectId: "delivery-local",
    storageBucket: "delivery-local.appspot.com",
    messagingSenderId: "412238987978",
    appId: "1:412238987978:web:0542f2aa38f646d3faaa33"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
